import { AxiosResponse } from "axios";
import {
  AddOnLabelPurchaseReportFiltersDto,
  AddOnLabelPurchaseReportResponse,
} from "@/models/AddOnLabelPurchaseReport";
import Repository from "./Repository";

const resource = "/AddOnLabelPurchaseReport";

export default {
  getReport(payload: AddOnLabelPurchaseReportFiltersDto): Promise<AxiosResponse<AddOnLabelPurchaseReportResponse>> {
    return Repository.post(`${resource}/GetReport`, payload, { withCredentials: true });
  },
  exportExcel(payload: AddOnLabelPurchaseReportFiltersDto): Promise<AxiosResponse<BlobPart>> {
    return Repository.post(`${resource}/ExportExcel`, payload, {
      withCredentials: true,
      responseType: "arraybuffer",
    });
  },
};
